/**
 * Chamadas à API de verificação facial (backend /face/*).
 * Fotos sempre em multipart; descritores como JSON string (campos de
 * multipart são strings).
 */
import api from './api';

export async function getFaceConfig() {
  const response = await api.get('/face/config');
  return response.data;
}

export async function updateFaceConfig(partial) {
  const response = await api.patch('/face/config', partial);
  return response.data;
}

/** Mapa { userId: quantidadeDeFotos } de todo mundo com cadastro. */
export async function getFaceStatus() {
  const response = await api.get('/face/status');
  return response.data;
}

export async function getUserFacePhotos(userId) {
  const response = await api.get(`/face/users/${userId}/photos`);
  return response.data;
}

/**
 * Cadastra as fotos de referência (substitui o cadastro anterior).
 * captures: [{ blob, descriptor }] na ordem dos slots.
 */
export async function enrollFacePhotos(userId, captures) {
  const formData = new FormData();
  captures.forEach((capture, i) => {
    formData.append('photos', capture.blob, `face-${i}.jpg`);
  });
  formData.append(
    'descriptors',
    JSON.stringify(captures.map((c) => Array.from(c.descriptor))),
  );
  const response = await api.post(`/face/users/${userId}/photos`, formData);
  return response.data;
}

export async function deleteFacePhotos(userId) {
  const response = await api.delete(`/face/users/${userId}/photos`);
  return response.data;
}

/**
 * Verifica a identidade: manda o descritor capturado ao vivo + foto de
 * evidência. Devolve { verificationId, success, similarity, threshold }.
 */
export async function verifyFace(userId, purpose, capture) {
  const formData = new FormData();
  formData.append('userId', userId);
  formData.append('purpose', purpose);
  formData.append('descriptor', JSON.stringify(Array.from(capture.descriptor)));
  if (capture.blob) {
    formData.append('photo', capture.blob, 'verify.jpg');
  }
  const response = await api.post('/face/verify', formData);
  return response.data;
}

export async function getRecentVerifications(limit = 50) {
  const response = await api.get('/face/verifications/recent', {
    params: { limit },
  });
  return response.data;
}

/** Totais da trilha de verificações (para dimensionar o expurgo). */
export async function getVerificationStats() {
  const response = await api.get('/face/verifications/stats');
  return response.data;
}

/** Exclui uma verificação (linha + foto de evidência). Só admin. */
export async function deleteVerification(verificationId) {
  const response = await api.delete(`/face/verifications/${verificationId}`);
  return response.data;
}

/** Expurgo em lote: `olderThanDays = 0` apaga todas. Só admin. */
export async function deleteVerifications(olderThanDays) {
  const response = await api.delete('/face/verifications', {
    params: { olderThanDays },
  });
  return response.data;
}

/**
 * As imagens são servidas por endpoint autenticado — <img src> direto não
 * manda o Bearer. Baixa como blob e devolve um object URL (quem chamar deve
 * dar URL.revokeObjectURL quando não precisar mais).
 */
export async function fetchFacePhotoUrl(photoId) {
  const response = await api.get(`/face/photos/${photoId}/image`, {
    responseType: 'blob',
  });
  return URL.createObjectURL(response.data);
}

export async function fetchVerificationPhotoUrl(verificationId) {
  const response = await api.get(`/face/verifications/${verificationId}/image`, {
    responseType: 'blob',
  });
  return URL.createObjectURL(response.data);
}
